var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_2552",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000305176H21.493V21.4941H0V0.000305176Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_2552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10844 18.6753C5.68844 18.6753 6.23544 18.8953 6.81444 19.1283C10.3614 20.7683 14.5564 20.0223 17.2894 17.2903C20.8954 13.6823 20.8954 7.8133 17.2894 4.2073C15.5434 2.46131 13.2214 1.50031 10.7494 1.50031C8.27644 1.50031 5.95344 2.46231 4.20844 4.20831C1.47444 6.94031 0.730437 11.1353 2.35544 14.6483C2.58944 15.2273 2.81544 15.7913 2.81544 16.3773C2.81544 16.9623 2.61444 17.5513 2.43744 18.0713C2.29144 18.4993 2.07044 19.1453 2.21244 19.2873C2.35144 19.4313 3.00144 19.2043 3.43044 19.0573C3.94544 18.8813 4.52944 18.6793 5.10844 18.6753ZM10.7244 21.4943C9.19644 21.4943 7.65844 21.1713 6.21944 20.5053C5.79544 20.3353 5.39844 20.1753 5.11344 20.1753C4.78544 20.1773 4.34444 20.3293 3.91844 20.4763C3.04444 20.7763 1.95644 21.1503 1.15144 20.3483C0.349437 19.5453 0.719437 18.4603 1.01744 17.5873C1.16444 17.1573 1.31544 16.7133 1.31544 16.3773C1.31544 16.1013 1.18244 15.7493 0.978437 15.2423C-0.894563 11.1973 -0.0285628 6.32231 3.14844 3.14731C5.17644 1.11831 7.87544 0.000305176 10.7484 0.000305176C13.6214 0.000305176 16.3214 1.11731 18.3494 3.14631C22.5414 7.3383 22.5414 14.1583 18.3494 18.3503C16.2944 20.4063 13.5274 21.4943 10.7244 21.4943Z",
    fill: "#FEFEFE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6954 12.163C14.1434 12.163 13.6914 11.716 13.6914 11.163C13.6914 10.61 14.1344 10.163 14.6864 10.163H14.6954C15.2474 10.163 15.6954 10.61 15.6954 11.163C15.6954 11.716 15.2474 12.163 14.6954 12.163Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6876 12.163C10.1356 12.163 9.68359 11.716 9.68359 11.163C9.68359 10.61 10.1256 10.163 10.6786 10.163H10.6876C11.2396 10.163 11.6876 10.61 11.6876 11.163C11.6876 11.716 11.2396 12.163 10.6876 12.163Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67978 12.163C6.12778 12.163 5.67578 11.716 5.67578 11.163C5.67578 10.61 6.11878 10.163 6.67078 10.163H6.67978C7.23178 10.163 7.67978 10.61 7.67978 11.163C7.67978 11.716 7.23178 12.163 6.67978 12.163Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlined);
export default __webpack_public_path__ + "static/media/chat-outlined.dc033649e01e87a5aed8badec91cba12.svg";
export { ForwardRef as ReactComponent };